import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { formatAddress } from '../../Dispatch/utils/utils';
import CustomerMergeIndicator from '../../../common/CustomerMergeIndicator';
const styles = (theme) => ({
  DetailsContainer: {
    marginTop: 14,
    marginBottom: 14
  },
  HeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  Name: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600
  },
  Address: {
    color: theme.subHeaderTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400
  }
});

const StopDetailsTitle = ({ classes, proData }) => (
  <div className={classes.DetailsContainer}>
    <div className={classes.HeaderContainer}>
      <span className={classes.Name}>
        {proData.displayCustomerName}
        <CustomerMergeIndicator displayCustomerName={proData.displayCustomerName} customerName={proData.customerName} />
      </span>
      <span className={classes.Name}>#{proData.displayCustomerCode}</span>
    </div>
    <div>
      <span className={classes.Address}>
        {formatAddress({
          address: proData.customerAddress,
          address2: proData.customerAddress2,
          city: proData.city,
          state: proData.state,
          zip: proData.zip
        })}
      </span>
    </div>
  </div>
);

export default withStyles(styles)(StopDetailsTitle);
